import React from 'react';
import Card from './MealReservationCard';
import './index.scss';
import { CountdownTimer, LocationCard, MealButton } from './molecules';
import Icon from './Icon';

function YourProduct({ children }) {
  return <>{children}</>;
}

const ImageCard = ({
  status,
  heading,
  description,
  unLocksAt,
  isCountDownVisible
}) => {
  return (
    <Card className="pre-book-status-model__your-product-card">
      <Card.Image />
      <div className="pre-book-status-model__your-product-inner-wrapper">
        <div>
          <Card.Chip>{status}</Card.Chip>
          <Card.Heading>{heading}</Card.Heading>
          <Card.Description>{description}</Card.Description>
        </div>
        {isCountDownVisible && <CountdownTimer endDate={unLocksAt} />}
      </div>
    </Card>
  );
};

const BookingInfoCard = ({
  preBookID,
  mobileNumber,
  amount,
  unLocksAt,
  redeemUntil
}) => {
  return (
    <section className="checkout-total" aria-label="Payment summary">
      <div className="checkout-total__payable">
        <span>Pre-book ID</span>
        <span>{preBookID}</span>
      </div>
      <div className="checkout-total__payable">
        <span>Account</span>
        <span>{mobileNumber}</span>
      </div>
      <div className="checkout-total__payable">
        <span>Amount paid</span>
        <span>₹ {amount}</span>
      </div>
      <div className="checkout-total__payable">
        <span>Unlocks</span>
        <span>{unLocksAt}</span>
      </div>
      <div className="checkout-total__payable">
        <span>Valid until</span>
        <span>{redeemUntil}</span>
      </div>
      <div className="checkout-total__payable">
        <span>Fulfilment</span>
        <span>Dine-in only</span>
      </div>
    </section>
  );
};

const TermsButton = ({ onClick }) => {
  return (
    <MealButton
      size="sm"
      className="navigation"
      endIcon={<Icon name="leftArrow" className="icon" />}
      onClick={onClick}
    >
      Pre-book terms and refund policy
    </MealButton>
  );
};

const RedeemButton = ({ onClick, ...props }) => {
  return (
    <MealButton
      className="pre-book-status-model__redeem-button"
      onClick={onClick}
      {...props}
    >
      REDEEM AT THIS RESTAURANT
    </MealButton>
  );
};

YourProduct.ImageCard = ImageCard;
YourProduct.BookingInfoCard = BookingInfoCard;
YourProduct.TermsButton = TermsButton;
YourProduct.LocationCard = LocationCard;
YourProduct.RedeemButton = RedeemButton;

export default YourProduct;
